export function isMobile() {
    // based on Bootstrap; see https://getbootstrap.com/docs/5.0/layout/breakpoints/#media-queries
    return window.screen.width < 768;
}
